import type { TypographyClasses } from '@micro-frontends/design-tokens/src/styles/efr/typography/typographyClasses';
import clsxWrap, { type ClassValue } from 'clsx';
type Inputs = (ClassValue | TypographyClasses)[];

export default (...inputs: Inputs) => {
	return clsxWrap(...inputs);
};
